import React, { useContext, useEffect, useState, useCallback } from "react";
import Masonry from '@mui/lab/Masonry';
import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Alert, Box, Button, Card, CardActions, CardHeader, Container, Paper, Typography, styled } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {PageSection} from "../template/TemplateElements";
//import {APIProvider, Marker, useMapsLibrary, useMap, createMarker} from '@vis.gl/react-google-maps';
import { collection, query, where, getDocs, getDoc, doc, setDoc, addDoc, deleteDoc, updateDoc, orderBy, startAt, endAt, documentId } from 'firebase/firestore';
import * as geofire from 'geofire-common';
import InfoDialog from "./InfoDialog";
import ChatDialog from "./ChatDialog";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ChatIcon from '@mui/icons-material/Chat';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Stack from '@mui/material/Stack';
import ProductCard from "./ProductCard";
import Link from '@mui/material/Link';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { green, cyan } from '@mui/material/colors';
import LinearProgress from '@mui/material/LinearProgress';
import { useNavigate } from "react-router-dom";
import Rating from '@mui/material/Rating';

const Matching = ({position}) => {
    // Helper to get all available timeslots for a list of provider user_ids
    // Helper: get all available timeslots for a list of provider user_ids
    async function getAllAvailableTimeSlots(providerUids) {
        const agendaRef = collection(firestoreInstance, '/agenda');
        const agendaQuery = query(agendaRef, where(documentId(), 'in', providerUids));
        const timeSlots = [];
        await Promise.all([getDocs(agendaQuery)]).then(([snapshot]) => {
            snapshot.forEach(record => {
                timeSlots.push({
                    slots: record.data().timeSlots,
                    user_id: record.id,
                });
            });
        }).catch(error => {
            //console.log('error', error);
        });
        return timeSlots;
    }

    // Helper: check if a timeslot is booked for a provider, date, and time
    async function isTimeslotBooked(providerId, dateStr, yearStr, timeSlotStr) {
        const schedulesRef = collection(firestoreInstance, '/schedules');
        const scheduleQuery = query(
            schedulesRef,
            where('date', '==', dateStr),
            where('year', '==', yearStr),
            where('time', '==', timeSlotStr),
            where('treatment.provider.user_id', '==', providerId)
        );
        const snapshot = await getDocs(scheduleQuery);
        return !snapshot.empty;
    }
    const { authInstance, firestoreInstance, functionsInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const { authUser } = useContext(AuthContext);
    const [matchingResults, setMatchingResults] = useState([]); 
    const [matchingTreatments, setMatchingTreatments] = useState([]); 
    const [loading, setLoading] = useState(false);
    const [openInfoDialog, setOpenInfoDialog] = useState(false);
    const [openChatDialog, setOpenChatDialog] = useState(false);
    const [dialogInfo, setDialogInfo] = useState(null);
    const navigate = useNavigate();

    const getNearbyPlaces = useCallback(async (position) => {
    //console.log("position", position);
    setLoading(true);
    setMatchingResults([]); //start a new search
        // LA 34.054908,-118.242643
        //const center = [34.054908, -118.242643];
        const center = [position.lat, position.lng];
        const radiusInM = 50 * 1000; //50km

        // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
        // a separate query for each pair. There can be up to 9 pairs of bounds
        // depending on overlap, but in most cases there are 4.
        const bounds = geofire.geohashQueryBounds(center, radiusInM);
        const promises = [];
        for (const b of bounds) {
            const q = query(
                collection(firestoreInstance, 'places'), 
                orderBy('geohash'), 
                startAt(b[0]), 
                endAt(b[1]));

            promises.push(getDocs(q));
        }
        //console.log('promises ', promises);

        // Collect all the query results together into a single list
        const snapshots = await Promise.all(promises);

        const matchingDocs = [];
        for (const snap of snapshots) {
            for (const doc of snap.docs) {
                const lat = doc.get('lat');
                const lng = doc.get('lng');

                // We have to filter out a few false positives due to GeoHash
                // accuracy, but most will match
                const distanceInKm = geofire.distanceBetween([lat, lng], center);
                const distanceInM = distanceInKm * 1000;
                if (distanceInM <= radiusInM) {
                matchingDocs.push(doc);
                }
            }
        }

        //console.log('matchingDocs', matchingDocs);

        const mResults = [];
        const matchedUsers = [];
        
        matchingDocs && matchingDocs
        .filter(matchingDoc => (Array.isArray(matchingDoc.data().users) && matchingDoc.data().users.length))
        .map((matchingDoc, index) => {
            const users = matchingDoc.data().users;
            for (const user of users) {
                matchedUsers.push({user_id:user, address: matchingDoc.data().address});
            }
        });
        /*
        
        //console.log('matchedUsers', matchedUsers);
        for (const user of matchedUsers) {
            const userRef = doc(firestoreInstance, "users", user.user_id);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
                user.user = userSnap.data();
                if (user.user.userType === 'Nurse') {
                    mResults.push(user);
                }
            }
        }
        console.log('mResults', mResults);
        setMatchingResults(mResults);

        */

        console.log('matchedUsers', matchedUsers);
        for (const user of matchedUsers) {
            //--- nurse profile common data ---
            const userRef = doc(firestoreInstance, "users", user.user_id);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
                user.user = userSnap.data();
                if (user.user.userType === 'Nurse') {
                    
                    //get existing user service account
                    const docRef = doc(firestoreInstance, "userServiceAccounts", user.user_id);
                    await getDoc(docRef).then(docSnap => {
                        if (docSnap.exists()) {
                            const data = docSnap.data();
                            //console.log("service account data:", data);
                            user.serviceAccount = data;
                        }
                    }).catch(err => {
                        //
                    });

                    //add treatment services
                    const servicesRef = collection(firestoreInstance, '/services');
                    const serviceQuery = query(servicesRef, where('user_id', '==', user.user_id));
                    
                    await getDocs(serviceQuery).then(async serviceSnapshot => {
                        const productIds = [];
                        serviceSnapshot.forEach(record => {
                            productIds.push(record.data().product_id);
                        });
                        //get the products
                        const treatmentsRef = collection(firestoreInstance, '/treatments');
                        const treatmentQuery = query(treatmentsRef, where(documentId(), 'in', productIds));

                        await getDocs(treatmentQuery).then(async treatmentSnapshot => {
                            const products = [];
                            for (const record of treatmentSnapshot.docs) {
                                const product = record.data();
                                product.product_id = record.id;
                                // Merge add-ons from all providers for this treatment, and fetch details from /treatments/{treatmentId}/add-ons
                                let mergedAddons = [];
                                for (const provider of [user]) { // user is the current provider
                                    const providerAddonsRef = collection(firestoreInstance, `/userServiceAccounts/${provider.user_id}/addons`);
                                    const providerAddonsSnapshot = await getDocs(providerAddonsRef);
                                    for (const addonDoc of providerAddonsSnapshot.docs) {
                                        const addon = addonDoc.data();
                                        if (addon.treatmentId === product.product_id) {
                                            // Fetch add-on details from /treatments/{treatmentId}/add-ons/{addonId}
                                            const addonDetailRef = doc(firestoreInstance, `/treatments/${product.product_id}/add-ons/${addonDoc.id}`);
                                            let addonDetail = {};
                                            try {
                                                const addonDetailSnap = await getDoc(addonDetailRef);
                                                if (addonDetailSnap.exists()) {
                                                    addonDetail = addonDetailSnap.data();
                                                }
                                            } catch (e) {
                                                // ignore missing details
                                            }
                                            mergedAddons.push({ id: addonDoc.id, ...addon, ...addonDetail });
                                        }
                                    }
                                }
                                product.addons = mergedAddons;
                                console.log('Merged add-ons with details for treatment', product.product_id, mergedAddons);
                                products.push(product);
                            }
                            user.services = products;
                            console.log('User services with add-ons:', user.services);
                            mResults.push(user);
                        }).catch(err => {});
                    }).catch(err => {});
                    
                    ///-----
                    /*
                    Promise.all([getDocs(serviceQuery)]).then(([serviceSnapshot]) => {
                        const productIds = [];
                        serviceSnapshot.forEach(record => {
                            productIds.push(record.data().product_id);
                        });
                        //get the products
                        const treatmentsRef = collection(firestoreInstance, '/treatments');
                        const treatmentQuery = query(treatmentsRef, where(documentId(), 'in', productIds));

                        Promise.all([getDocs(treatmentQuery)]).then(([treatmentSnapshot]) => {
                            const products = [];
                            treatmentSnapshot.forEach(record => {
                                products.push(record.data());
                            });
                            user.services = products;
                            //console.log('user', user);
                            mResults.push(user);
                            //console.log('user', user);
                            //setMatchingResults(mResults);
                            console.log('mResults0', mResults);
                        }).catch(error => {
                            //
                        });
                    }).catch(error => {
                        //
                    });  
                    */          
                }
            }
            //--- nurse profile common data ---
        }
        //console.log('mResults1', mResults);
        setMatchingResults(mResults);
        
        //build matchingTreatments from mResults
        // Build a global treatments list
        const treatmentsMap = new Map();
        for (const user of mResults) {
            for (const service of user.services) {
                // Add provider info to service
                if (!service.providers) service.providers = [];
                service.providers.push(user);
                if (!treatmentsMap.has(service.product_id)) {
                    treatmentsMap.set(service.product_id, { ...service, providers: [user] });
                } else {
                    // Add provider to existing treatment
                    const existing = treatmentsMap.get(service.product_id);
                    existing.providers.push(user);
                }
            }
        }

        // For each treatment, merge add-ons from all providers who offer it and deduplicate by add-on ID
        const treatments = [];
        for (const [product_id, treatment] of treatmentsMap.entries()) {
            let mergedAddons = [];
            for (const provider of treatment.providers) {
                const providerAddonsRef = collection(firestoreInstance, `/userServiceAccounts/${provider.user_id}/addons`);
                // eslint-disable-next-line no-await-in-loop
                const providerAddonsSnapshot = await getDocs(providerAddonsRef);
                for (const addonDoc of providerAddonsSnapshot.docs) {
                    const addon = addonDoc.data();
                    if (addon.treatmentId === product_id) {
                        // Fetch add-on details from /treatments/{product_id}/add-ons/{addonDoc.id}
                        const addonDetailRef = doc(firestoreInstance, `/treatments/${product_id}/add-ons/${addonDoc.id}`);
                        let addonDetail = {};
                        try {
                            // eslint-disable-next-line no-await-in-loop
                            const addonDetailSnap = await getDoc(addonDetailRef);
                            if (addonDetailSnap.exists()) {
                                addonDetail = addonDetailSnap.data();
                            }
                        } catch (e) {
                            // ignore missing details
                        }
                        mergedAddons.push({ id: addonDoc.id, ...addon, ...addonDetail });
                    }
                }
            }
            // Deduplicate add-ons by ID
            const uniqueAddons = Object.values(mergedAddons.reduce((acc, addon) => {
                acc[addon.id] = addon;
                return acc;
            }, {}));
            treatment.addons = uniqueAddons;
            treatments.push(treatment);
        }

        // Filter treatments by truly available timeslots (not expired, not booked)
        const filteredTreatments = [];
        const now = new Date();
        for (const treatment of treatments) {
            let treatmentHasAvailable = false;
            const providerUids = treatment.providers.map(p => p.user_id);
            // eslint-disable-next-line no-await-in-loop
            const timeSlotsArr = await getAllAvailableTimeSlots(providerUids);
            for (const ts of timeSlotsArr) {
                if (!Array.isArray(ts.slots)) continue;
                for (const slotObj of ts.slots) {
                    // slotObj.day: unix timestamp for the day
                    // slotObj.slots: array of { timeSlot: '8:00am - 10:00am', ... }
                    // Only consider slots for today or future
                    const slotDay = new Date(slotObj.day * 1000);
                    if (slotDay < now.setHours(0,0,0,0)) continue; // expired day
                    for (const slot of slotObj.slots) {
                        // If slot time is expired for today, skip
                        if (slotDay.toDateString() === now.toDateString()) {
                            // Parse hour from slot.timeSlot
                            if (typeof slot.timeSlot === 'string' && slot.timeSlot.includes(':')) {
                                const hour = parseInt(slot.timeSlot.split(':')[0], 10);
                                if (now.getHours() >= hour) continue;
                            } else {
                                // If timeSlot is not a string, skip this slot
                                continue;
                            }
                        }
                        // Check if slot is already booked
                        const dateStr = slotDay.toLocaleString('en-US', { month: 'short', day: 'numeric' });
                        const yearStr = slotDay.getFullYear().toString();
                        const timeSlotStr = slot.timeSlot;
                        // eslint-disable-next-line no-await-in-loop
                        const booked = await isTimeslotBooked(ts.user_id, dateStr, yearStr, timeSlotStr);
                        if (!booked) {
                            treatmentHasAvailable = true;
                            break;
                        }
                    }
                    if (treatmentHasAvailable) break;
                }
                if (treatmentHasAvailable) break;
            }
            if (treatmentHasAvailable) {
                filteredTreatments.push(treatment);
            }
        }
    setMatchingTreatments(filteredTreatments);
    setLoading(false);
    }, [position]);

    useEffect(() => {
        getNearbyPlaces(position);
    },[getNearbyPlaces]);

    const showDetails = (dialogInfo) => {
        setOpenInfoDialog(true);
        setDialogInfo(dialogInfo);
    }

    const startChat = (item) => {
        //console.log('item', item);
        setOpenChatDialog(true);
        setDialogInfo(item);
    }

    const insideAvatarFunction = (e, item) => {
        //if (authUser.userType != 'Nurse') {
            e.stopPropagation();
            //console.log('item', item);
            const slug = item.serviceAccount ? item.serviceAccount.slug : '';
            navigate(config.pathnames.NurseProfile.replace(":nurseSlug", slug));
            //showDetails(item);
            //console.log('Fired insideAvatarFunction()!');
        //}
    }
    
    const everywhereClickFunction = (e, item) => {
        //console.log('Fired everywhereClickFunction()!');
        showDetails(item);
    }

    const handleOpenDialog = (dialogIsOpen) => {
        setOpenInfoDialog(dialogIsOpen);
    }

    const handleOpenChatDialog = (dialogIsOpen) => {
        setOpenChatDialog(dialogIsOpen);
    }

    return (
        <>
        {loading ? (
            <PageSection>
                <Box sx={{px: {xs:0, md:2}}}><LinearProgress color="success"/></Box>
            </PageSection>
        ) : (
            <PageSection>
                <Box sx={{ width: '100%', px: { xs: 0, md: 1 }, py: 2 }}>
                    {matchingTreatments && matchingTreatments.length > 0 ? (
                        <Masonry columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} spacing={{ xs: 0, sm: 0, md: 2, lg: 2 }} style={{ margin: '0 auto' }}>
                            {matchingTreatments.map((service, index) => (
                                <Paper key={service.product_id || index} sx={{ p: 1, mb: 2 }} elevation={2}>
                                    <ProductCard service={service} showDetails={showDetails} />
                                </Paper>
                            ))}
                        </Masonry>
                    ) : (
                        <Typography variant="body1" align="center">No available treatments found.</Typography>
                    )}
                </Box>
            </PageSection>
        )}
            <InfoDialog openDialog={openInfoDialog} handleOpenDialog={handleOpenDialog} dialogInfo={dialogInfo} />
            {/*<ChatDialog openDialog={openChatDialog} handleOpenDialog={handleOpenChatDialog} dialogInfo={dialogInfo} />*/}
        </>
    )
}

export default Matching;
